import { render } from "./DatenSchutz.vue?vue&type=template&id=bec5027a"
import script from "./DatenSchutz.vue?vue&type=script&lang=js"
export * from "./DatenSchutz.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__